import { useMutation } from '@tanstack/react-query';
import { exportacaoService } from '../services/exportacaoService';
import type { FiltrosPainel } from '../types/Painel';

export function useExportar(id: string) {
  return useMutation({
    mutationFn: (usoInterno: boolean) => exportacaoService.baixar(id, usoInterno),
  });
}

export function useExportarParticipantes(id: string) {
  return useMutation({
    mutationFn: (filtros: FiltrosPainel) => exportacaoService.baixarParticipantes(id, filtros),
  });
}
